const PRIVATE_PATHS = ['/orders', '/customers', '/transactions', '/providers/debts', '/maps', '/search', '/products', '/offers', '/reports'];
export function isPrivateBusinessPath(path: string): boolean {
  const normalized = path.split(/[?#]/, 1)[0].replace(/\/$/, '') || '/';
  return PRIVATE_PATHS.some(prefix => normalized === prefix || normalized.startsWith(prefix + '/'));
}
